import axiosInterceptor from "../helpers/Interceptor";
import { APIs } from "../constants/Constants";

/**
 * Fetches a short-lived Deepgram JWT from our own backend.
 *
 * The Deepgram API key itself stays server-side and is never shipped to the
 * browser. This endpoint requires an authenticated session, so only a logged-in
 * user can mint a token, and the token it returns expires within a minute.
 *
 * @returns {Promise<string|null>} the access token, or null if it couldn't be obtained.
 */
export const getDeepgramToken = async () => {
  try {
    const response = await axiosInterceptor.get(APIs.DEEPGRAMTOKEN);
    return response?.data?.access_token || null;
  } catch (error) {
    console.error("Could not obtain a Deepgram token.", error);
    return null;
  }
};
